import MuiTooltip, { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';
import { styled } from '../styles';

import Typography from '../Typography';

export interface Props extends Omit<MUITooltipProps, 'title'> {
  title?: string;
  content?: string;
  placement?: 'bottom-start' | 'bottom-end';
  describeChild?: boolean;
}

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const Tooltip = ({
  children,
  title = '',
  content = '',
  placement = 'bottom-start',
  describeChild = false,
  open,
}: Props) => {
  const shouldShowTooltip = Boolean(title) || Boolean(content);

  return (
    <MuiTooltip
      enterTouchDelay={0}
      leaveTouchDelay={700}
      title={
        shouldShowTooltip ? (
          <Container sx={{ padding: title && content ? 2 : 1 }}>
            {title && (
              <Typography variant="subheadingSmall" color="inherit">
                {title}
              </Typography>
            )}
            {content && (
              <Typography
                variant="caption"
                dangerouslySetInnerHTML={{ __html: content }}
                color="inherit"
                sx={{
                  '& *': {
                    color: 'inherit',
                    fontSize: 'inherit',
                    lineHeight: 'inherit',
                  },
                  '& ul': {
                    margin: 0,
                    paddingLeft: 2,
                  },
                  ...(title && { paddingTop: 1 }),
                }}
              />
            )}
          </Container>
        ) : (
          ''
        )
      }
      placement={placement}
      arrow
      describeChild={describeChild}
      open={open}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
